module.exports = __webpack_public_path__ + "static/slide3@2x-2ec60088f5bb79728c298c9ce824ee77.png";